import { createNavigation } from 'next-intl/navigation'

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
const createNextNavigation = (i18nRouting: Parameters<typeof createNavigation>[number]) =>
  createNavigation(i18nRouting)

export default createNextNavigation
